export default __webpack_public_path__ + "static/media/paddy-considine-rhys-ifans.01229322.jpg";